import { motion } from "framer-motion";
import { Star } from "lucide-react";
import { fadeInUpSm } from "@/lib/motion-variants";

// One small component per celebration type — keeps the parent overlay flat.
const BadgeBody = ({ badge }) => (
  <div className="space-y-2">
    <p className="text-xl font-semibold text-white">{badge.name}</p>
    <p className="text-slate-400 text-sm">{badge.description}</p>
    <div className="flex items-center justify-center gap-2 mt-3">
      <Star className="w-5 h-5 text-amber-400 fill-amber-400" />
      <span className="text-amber-400 font-bold">+{badge.points} XP</span>
    </div>
  </div>
);

const LevelUpBody = ({ level }) => (
  <div className="space-y-2">
    <p className="text-4xl mb-2">{level.icon}</p>
    <p className="text-xl font-semibold text-white">{level.name}</p>
    <p className="text-violet-400">Level {level.level}</p>
  </div>
);

const StreakBody = ({ days }) => (
  <div className="space-y-2">
    <p className="text-4xl font-bold text-orange-400">{days} Days</p>
    <p className="text-slate-400">Keep up the amazing work!</p>
  </div>
);

const XpBody = ({ amount }) => (
  <div className="space-y-2">
    <p className="text-3xl font-bold text-cyan-400">+{amount} XP</p>
  </div>
);

const RENDERERS = {
  badge: ({ data }) => (data?.badge ? <BadgeBody badge={data.badge} /> : null),
  levelUp: ({ data }) => (data?.level ? <LevelUpBody level={data.level} /> : null),
  streak: ({ data }) => <StreakBody days={data?.days || 0} />,
  xp: ({ data }) => <XpBody amount={data?.amount || 0} />,
};

export function CelebrationBody({ type, data }) {
  const Renderer = RENDERERS[type];
  if (!Renderer) return null;
  return (
    <motion.div {...fadeInUpSm} transition={{ delay: 0.4 }}>
      <Renderer data={data || {}} />
    </motion.div>
  );
}

export default CelebrationBody;
